import { withVersion } from 'api/utils/withVersion';
export var getTokensPath = function getTokensPath() {
    return withVersion.v1("/tokens");
};
export var getTokensRenewPath = function getTokensRenewPath() {
    return withVersion.v1('/tokens/renew');
};
